function isObject(thing) {
  return thing != null;
}
export function isSdkError(err) {
  return isObject(err) && err.status != null;
}
export function sdkErrorToMinimalHttpError(err) {
  return {
    response: {
      data: {
        details: err.details
      },
      status: err.status
    },
    requestId: err.requestId
  };
}
//# sourceMappingURL=sdkErrorDecoders.js.map